/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_A7_IntroInputs */

const es_marketplace_seo_spain_faq_a7_intro = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para ser tú el patrón en un alquiler sin tripulación, la embarcación debe encajar con tu titulación náutica española (o equivalente homologada). Resumen orientativo:`)
};

const gl_marketplace_seo_spain_faq_a7_intro = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para ser ti o patrón nun alugueiro sen tripulación, a embarcación debe encaixar coa túa titulación náutica española (ou equivalente homologada). Resumo orientativo:`)
};

const en_marketplace_seo_spain_faq_a7_intro = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To be your own skipper on a bareboat rental, the vessel must match your Spanish boating qualification (or recognised equivalent). Quick guide:`)
};

/**
* | output |
* | --- |
* | "To be your own skipper on a bareboat rental, the vessel must match your Spanish boating qualification (or recognised equivalent). Quick guide:" |
*
* @param {Marketplace_Seo_Spain_Faq_A7_IntroInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_a7_intro = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_A7_IntroInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_A7_IntroInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_a7_intro(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_a7_intro(inputs)
	return es_marketplace_seo_spain_faq_a7_intro(inputs)
});